var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1331 10.1834C10.1081 10.1834 10.0915 10.1834 10.0665 10.1834C10.0248 10.1751 9.96647 10.1751 9.91647 10.1834C7.4998 10.1084 5.6748 8.20841 5.6748 5.86675C5.6748 3.48341 7.61647 1.54175 9.9998 1.54175C12.3831 1.54175 14.3248 3.48341 14.3248 5.86675C14.3165 8.20841 12.4831 10.1084 10.1581 10.1834C10.1498 10.1834 10.1415 10.1834 10.1331 10.1834ZM9.9998 2.79175C8.30814 2.79175 6.92481 4.17508 6.92481 5.86675C6.92481 7.53341 8.2248 8.87508 9.88314 8.93341C9.9248 8.92508 10.0415 8.92508 10.1498 8.93341C11.7831 8.85841 13.0665 7.51675 13.0748 5.86675C13.0748 4.17508 11.6915 2.79175 9.9998 2.79175Z",
    fill: "#093554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1413 19.2916C8.50801 19.2916 6.86634 18.8749 5.62467 18.0416C4.46634 17.2749 3.83301 16.2249 3.83301 15.0833C3.83301 13.9416 4.46634 12.8833 5.62467 12.1083C8.12467 10.4499 12.1747 10.4499 14.658 12.1083C15.808 12.8749 16.4497 13.9249 16.4497 15.0666C16.4497 16.2083 15.8163 17.2666 14.658 18.0416C13.408 18.8749 11.7747 19.2916 10.1413 19.2916ZM6.31634 13.1583C5.51634 13.6916 5.08301 14.3749 5.08301 15.0916C5.08301 15.7999 5.52467 16.4833 6.31634 17.0083C8.39134 18.3999 11.8913 18.3999 13.9663 17.0083C14.7663 16.4749 15.1997 15.7916 15.1997 15.0749C15.1997 14.3666 14.758 13.6833 13.9663 13.1583C11.8913 11.7749 8.39134 11.7749 6.31634 13.1583Z",
    fill: "#093554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.4ae8652dbbed3d179c96e121f9d4b151.svg";
export { ForwardRef as ReactComponent };